/**
 * Location data for MarQ Capital offices
 * Contains coordinates and display information for each location
 */
export const officeLocations = [
  {
    id: 'london',
    name: 'London',
    label: 'MarQ Capital HQ',
    coords: {
      lat: 51.51351426405887,
      lng: -0.08229884732426473
    },
    zoomLevel: 13,
    details:
      'Level 30, The Leadenhall Building\n122 Leadenhall Street\nLondon EC3V 4AB, UK\n+44 20 4587 3860',
    isHeadquarters: true
  },
  {
    id: 'dubai',
    name: 'Dubai',
    label: 'MarQ Capital Office',
    coords: {
      lat: 25.217482896401336,
      lng: 55.28236993308594
    },
    zoomLevel: 12,
    details: 'Levels 41 & 42, Emirates Towers\nSheikh Zayed Road\nDubai',
    isHeadquarters: false
  },
  {
    id: 'singapore',
    name: 'Singapore',
    label: 'MarQ Capital Office',
    coords: {
      lat: 1.2795824,
      lng: 103.8538296
    },
    zoomLevel: 13,
    details:
      'Level 39, Marina Bay Financial Centre Tower 2\n10 Marina Boulevard, Singapore\n+65 3158 0286',
    isHeadquarters: false
  }
];

/**
 * Group office locations by continent
 */
export const officesByContinent = [
  {
    continent: 'Europe',
    offices: [officeLocations.find(office => office.id === 'london')]
  },
  {
    continent: 'Middle East',
    offices: [officeLocations.find(office => office.id === 'dubai')]
  },
  {
    continent: 'Asia',
    offices: [officeLocations.find(office => office.id === 'singapore')]
  }
];

/**
 * Contact email addresses for MarQ Capital
 */
export const contactEmails = [
  {
    label: 'Investors Information',
    email: 'investor-info@mqcapital.co.uk'
  },
  { label: 'General Inquiries', email: 'inquiries@mqcapital.co.uk' },
  {
    label: 'Recruitment Inquiries',
    email: 'recruiting@mqcapital.co.uk'
  },
  {
    label: 'Dealing Desk Operations (24h)',
    email: 'dealingdesk@mqcapital.co.uk'
  },
  { label: 'Complaints', email: 'compliance@mqcapital.co.uk' }
];
